import { useEffect, useState } from "react";
import { Icon } from "nystem-components";

export default () => {
  const [state, setState] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!navigator.remotor) return;
    let active = true;
    let timer;
    const update = async () => {
      try {
        const state = await navigator.remotor.request("status");
        if (active) setState(state);
      } catch (error) {
        if (active) setError(error.message);
      }
      if (active) timer = setTimeout(update, 2000);
    };
    update();
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, []);
  const send = async (op, args) => {
    setBusy(true);
    setError("");
    try {
      setState(await navigator.remotor.request(op, args));
    } catch (error) {
      setError(error.message);
    } finally {
      setBusy(false);
    }
  };
  if (!state) return null;
  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        aria-label="iPhone Live Activity"
        aria-pressed={state.liveActivity}
        disabled={busy}
        title={`iPhone Live Activity: ${state.liveActivity ? "on" : "off"}`}
        onClick={() => send("configure", { liveActivity: !state.liveActivity })}
        className={`rounded-xl border p-2 disabled:opacity-40 ${state.liveActivity ? "border-sky-400/50 bg-sky-400/10 text-sky-300" : "border-gray-700 text-gray-400"}`}
      >
        <Icon icon="mobile-screen-button" className="size-5" />
      </button>
      <details className="relative">
        <summary
          className="cursor-pointer list-none rounded p-1"
          aria-label="Bluetooth relay settings"
          title="Bluetooth relay"
        >
          <Icon icon="tower-broadcast" className="size-5" />
        </summary>
        <div className="fixed top-14 right-2 z-30 max-h-[80vh] w-80 max-w-[calc(100vw-1rem)] space-y-3 overflow-auto rounded-xl border border-gray-700 bg-gray-900 p-4 text-sm shadow-xl">
          <p className="font-semibold">Bluetooth relay</p>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={state.enabled}
              disabled={busy}
              onChange={(event) => send("configure", { enabled: event.target.checked })}
            />
            Relay sensor readings
          </label>
          <p>{state.status}</p>
          <p className="text-gray-400">
            {state.serverStatus} · {state.relayed} readings relayed
          </p>
          {(error || state.problem) && (
            <p role="alert" className="text-amber-300">
              {error || state.problem}
            </p>
          )}
          {state.devices.map((device) => (
            <label key={device.id} className="block space-y-1">
              <span>{device.name}</span>
              <select
                className="w-full rounded border border-gray-700 bg-gray-950 p-2"
                disabled={busy}
                value={state.mappings[device.id] || ""}
                onChange={(event) => send("map", { id: device.id, device: event.target.value })}
              >
                <option value="">Do not relay</option>
                {state.sensors
                  .filter(
                    (sensor) =>
                      sensor.bluetoothModel === (device.key === "fe95" ? "Xiaomi LYWSDCGQ/01ZM" : "Govee H5075"),
                  )
                  .map((sensor) => (
                    <option key={sensor.id} value={sensor.id}>
                      {sensor.name}
                    </option>
                  ))}
              </select>
            </label>
          ))}
          <p className="text-xs text-gray-400">
            The server uses iPhone readings when it cannot hear a sensor. Background scanning can pause with the screen
            off.
          </p>
        </div>
      </details>
      {error && (
        <span role="status" className="sr-only">
          {error}
        </span>
      )}
    </div>
  );
};
